import * as React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";

import DatePicker from "material-ui/DatePicker";

let OFFSET = 0;
let LIMIT = 10;

class BankSettlements extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      limit: LIMIT,
      bank_settlements: [],
      loading: false,
      offset: OFFSET,
      created_at_from: null,
      created_at_to: null
    };

    // FILTER
    this.filterFrom = this.filterFrom.bind(this);
    this.filterTo = this.filterTo.bind(this);

    // PAGINATION
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);

    // DATA LOAD
    this.loadBankSettlements = this.loadBankSettlements.bind(this);
  }

  componentDidMount() {
    this.loadBankSettlements(
      this.state.created_at_from,
      this.state.created_at_to,
      0
    );
    this.props.setHeader({
      title: "Bank Settlements",
      description: "SnapScan Bank Settlements"
    });
  }

  loadBankSettlements(createdAtFrom: any, createdAtTo: any, offset: any) {
    this.setState({
      bank_settlements: [],
      loading: true,
      offset: offset,
      created_at_from: createdAtFrom,
      created_at_to: createdAtTo
    });

    this.props.bank_settlements.fetchMore({
      variables: {
        created_at_from: createdAtFrom,
        created_at_to: createdAtTo,
        offset: offset
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          bank_settlements: [...fetchMoreResult.bank_settlements],
          loading: false
        });
      }
    });
  }

  goNext() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) + parseInt(this.state.limit, 10);
    this.loadBankSettlements(
      this.state.created_at_from,
      this.state.created_at_to,
      TMP_OFFSET
    );
  }
  goPrev() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) - parseInt(this.state.limit, 10);
    this.loadBankSettlements(
      this.state.created_at_from,
      this.state.created_at_to,
      TMP_OFFSET
    );
  }

  filterFrom(event: any, date: any) {
    this.loadBankSettlements(date, this.state.created_at_to, 0);
  }
  filterTo(event: any, date: any) {
    this.loadBankSettlements(this.state.created_at_from, date, 0);
  }

  render() {
    let bankSettlementsList =
      this.state.bank_settlements && this.state.bank_settlements.length > 0
        ? this.state.bank_settlements
        : [];

    const showList = () => {
      if (bankSettlementsList.length > 0) {
        let checkBatchID = batch => {
          if (batch) {
            return (
              <Link
                className="blueLink"
                to={`/snapscan/settlements/batches/${batch.id}/summary`}
              >
                {batch.id}
              </Link>
            );
          } else {
            return null;
          }
        };

        return bankSettlementsList.map((val, key) => {
          return (
            <tr key={key}>
              <td>{val.created_at}</td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/settlements/bank_settlements/${val.id}/summary`}
                >
                  {val.id}
                </Link>
              </td>
              <td>{val.status}</td>
              <td>{val.bank_name}</td>
              <td>{checkBatchID(val.settlement_batch)}</td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/merchants/${val.merchant.id}/payments`}
                >
                  {" "}
                  {val.merchant.name}{" "}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={val.merchant.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
            </tr>
          );
        });
      }
    };

    return (
      <section id="Ops_PaymentsList" className="padded">
        <h3
          style={{
            borderBottom: "1px solid rgb(204, 204, 204)",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
            marginTop: 0
          }}
        >
          <span style={{ marginRight: "10px" }}>Bank Settlements: </span>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start"
            }}
          >
            <DatePicker
              hintText="From"
              onChange={this.filterFrom}
              style={{
                width: "200px",
                marginRight: "10px"
              }}
              textFieldStyle={{
                width: "200px"
              }}
            />
            <DatePicker
              hintText="To"
              onChange={this.filterTo}
              style={{
                width: "200px",
                marginRight: "10px"
              }}
              textFieldStyle={{
                width: "200px"
              }}
            />
          </div>
        </h3>
        <div
          id="setHeight"
          style={{
            height: "calc(100% - 90px)",
            overflow: "auto"
          }}
        >
          <table
            style={{
              width: "100%"
            }}
            className={`BOTable`}
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th>Date</th>
                <th>ID</th>
                <th>Status</th>
                <th>Bank</th>
                <th>Batch ID</th>
                <th>Merchant</th>
              </tr>
            </thead>
            <tbody className={`${this.state.loading ? "hidden" : "shown"}`}>
              {showList()}
            </tbody>
          </table>
        </div>
        <button
          className={
            this.state.offset === 0 || this.state.loading ? "hidden" : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={() => this.goPrev()}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          className={
            bankSettlementsList.length < LIMIT || this.state.loading
              ? "hidden"
              : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={() => this.goNext()}
        >
          <i className="fa fa-chevron-right" />
        </button>
      </section>
    );
  }
}

// QUERIES
const BankSettlementsGQ = graphql(
  gql`
    query BankSettlements(
      $offset: Int
      $limit: Int
      $created_at_from: String
      $created_at_to: String
    ) {
      bank_settlements(
        offset: $offset
        limit: $limit
        created_at_from: $created_at_from
        created_at_to: $created_at_to
      ) {
        created_at
        id
        bank_name
        status
        settlement_batch {
          id
        }
        merchant {
          name
          id
          snapmin_url
        }
      }
    }
  `,
  {
    name: "bank_settlements",
    options(props: any) {
      return {
        variables: {
          created_at_from: null,
          created_at_to: null,
          offset: OFFSET,
          limit: LIMIT
        }
      };
    }
  }
);

const BankSettlementsList = compose(BankSettlementsGQ)(BankSettlements);
export default BankSettlementsList;
